export const tabsData = [
    {
        label: 'Import bank transactions',
        path: '/import-bank-transactions',
    },
    {
        label: 'Upload Transactions',
        path: '/upload-transactions',
    },
];
